module.exports = __webpack_public_path__ + "img/fujistring.389656b6.jpg";